<template>
  <div class="payMentDetails">
    <el-dialog :title="$t('customerService.process_refund_transactions')" :visible.sync="dialogTableVisible" width="580px" class="diglog-card" @open="getDetailInfo">
      <div>
        <div class="total">
          <div class="total-item">
            <div class="total-title">{{ $t('data.refund_amount') }}:</div>
            <div class="total-num color-main-linear-blue">{{ $store.getters.currency }} {{ merchantInfo.this_time_refund_amount | toDivideWithDot }}</div>
          </div>
          <div class="total-item">
            <div class="total-title">{{ $t('customerService.original_transaction_amount') }}:</div>
            <div class="total-num color-main-linear-blue">{{ $store.getters.currency }} {{ merchantInfo.original_transaction_amount | toDivideWithDot }}</div>
          </div>
        </div>

        <div class="section-title mb-12 mt-12">
          {{ $t('data.timeline') }}
        </div>

        <div class="line-bottom-1px" />
        <div class="item">
          <span class="item-left content-blue">{{ $t('components.create_time') }}</span>
          <span class="content-gray">{{ merchantInfo.transaction_create_time }}</span>
        </div>

        <div class="item">
          <span class="item-left content-blue">{{ $t('merchantAccount.complete_time') }}</span>
          <span class="content-gray">{{ merchantInfo.transaction_return_time }}</span>
        </div>

        <div class="section-title mb-12 mt-36">
          {{ $t('data.description') }}
        </div>
        <div class="line-bottom-1px" />

        <div class="item">
          <span class="item-left content-blue">{{ $t('customerService.original_transaction_id') }}</span>
          <span class="content-gray">{{ merchantInfo.original_transaction_id }}</span>
        </div>
        <div class="item">
          <span class="item-left content-blue">{{ $t('customerService.refund_transaction_id') }}</span>
          <span class="content-gray">{{ merchantInfo.refund_transaction_id }}</span>
        </div>

        <div class="item">
          <span class="item-left content-blue">{{ $t('customerService.refund_type') }}</span>
          <span class="content-gray">{{ getRefundStatusMapLabel(merchantInfo.refund_category) }}</span>
        </div>

        <div class="item">
          <span class="item-left content-blue">{{ $t('customerService.cumulative_amount_refunded') }}</span>
          <span class="content-gray">{{ Math.abs(merchantInfo.refunded_amount) | toDivideWithDot }}</span>
        </div>

        <div class="item">
          <span class="item-left content-blue">{{ $t('customerService.present_refund_amount') }}</span>
          <span class="content-gray">{{ Math.abs(merchantInfo.this_time_refund_amount) | toDivideWithDot }}</span>
        </div>

        <div class="item">
          <span class="item-left content-blue">{{ $t('customerService.transaction_fee_change_mode') }}</span>
          <span class="content-gray">{{ getTransactionFeeMode(merchantInfo.fee_split_type) }}</span>
        </div>

        <div class="item">
          <span class="item-left content-blue">{{ $t('customerService.refunded_transaction_fee') }}</span>
          <span class="content-gray">{{ Math.abs(merchantInfo.refund_transaction_fee) | toDivideWithDot }}</span>
        </div>

        <div class="item">
          <span class="item-left content-blue">{{ $t('customerService.actual_refund_amount_received') }}</span>
          <span class="content-gray">{{ Math.abs(merchantInfo.actual_receive_refund_amount) | toDivideWithDot }}</span>
        </div>

        <div class="section-title" />
        <div class="line-bottom-1px mt-24" />
        <div class="item">
          <span style="color: #71110e; margin-right: 4px;">*</span>
          <span class="item-left content-gray">{{ $t('customerService.refund_order_status') }}</span>
          <el-radio v-model="search.refund_order_status" label="true">{{ $t('components.cancel') }}</el-radio>
        </div>
        <div class="item">
          <span class="item-left content-blue">{{ $t('data.remark') }}</span>

          <el-input
            v-model="search.remark"
            type="textarea"
            :rows="3"
          />

        </div>
        <div slot="footer" class="dialog-footer mt-48" style="text-align: right;">
          <el-button type="primary" style="width: 170px;" plain @click="dialogTableVisible=false">{{ $t('components.cancel') }}</el-button>
          <el-button type="primary" style="width: 170px;" :disabled="!search.refund_order_status" @click="onClickSubmitBtn">{{ $t('components.confirm') }}</el-button>
        </div>

        <el-tag :type="getRefundTypeMapType(merchantInfo.status)" class="payin-status tag-custom"> {{ getRefundTypeMap(merchantInfo.status) }}</el-tag>
      </div></el-dialog>
  </div>
</template>

<script>
import { refundCancel, refundDetail } from '@/api/customer-service/customer-service'
import { payTransactionStatusMap, transactionFeeMode, refundTypeMap, refundStatusMap } from '@/utils/maps'
export default {
  name: 'Refund_Modal',
  components: {
  },
  props: {
    detailId: {
      type: [Number, String],
      default: '0'
    }
  },
  data() {
    return {
      dialogTableVisible: false,
      listLoading: false,
      search: {
        refund_order_status: false
      },
      data: {},
      merchantInfo: { merchant: { merchant_basic_info: {}}, payment_fee: {}} // 用户基本信息
    }
  },
  computed: {
    getRefundStatusMapLabel() {
      return function(value) {
        return refundStatusMap(value).label
      }
    },
    getPayTransactionStatusMap() {
      return function(value) {
        return payTransactionStatusMap(value).label
      }
    },
    getTansationFeeModeLabel() {
      return function(value) {
        return transactionFeeMode(value).label
      }
    },
    getRefundTypeMapType() {
      return function(value) {
        return refundTypeMap(value).type
      }
    },
    getRefundTypeMap() {
      return function(value) {
        return refundTypeMap(value).label
      }
    },
    getTransactionFeeMode() {
      return function(value) {
        return transactionFeeMode(value).label
      }
    }
  },
  mounted() {
  },
  methods: {
    getDetailInfo() {
      const params = { refund_transaction_id: this.data.refund_transaction_id }
      refundDetail(params).then(res => {
        if (res.code === 10000) {
          this.merchantInfo = res.data
        }
      })
      this.search = {
        refund_order_status: false
      }
    },
    // 改变弹框状态
    changModalStatus(value, data) {
      this.dialogTableVisible = value
      this.data = data
    },
    onClickSubmitBtn() {
      const params = { refund_transaction_id: this.data.refund_transaction_id, remark: this.search.remark }
      refundCancel(params).then(res => {
        if (res.code === 10000) {
          this.search = {
            refund_order_status: false
          }
          this.dialogTableVisible = false
          this.$emit('updateList')
          this.$message.success('Success')
        }
      })
    },
    onClickCancal() {
      this.changModalStatus(false)
    }
  }
}
</script>

<style scoped lang="scss">
.total{
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  .total-item{
    flex: 1;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid rgba(54, 66, 80, 0.20);
    &:nth-child(1){
      margin-right: 24px;
    }
  }
  &-title{
    color: #364250;
    font-size: 12px;
    font-weight: 600;
  }
  &-num{
    margin-top: 12px;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.2;
    color: #3855F1;
  }
}
.item{
  display: flex;
  margin-top: 16px;
  .item-left{
    display: inline-block;
    width: 250px;
  }
}

.content-blue{
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #364250;
}
.content-gray{
  flex: 1;
  text-align: right;
  font-weight: 500;
  font-size: 14px;
  line-height: 15px;
  color: #488CE8;
}

.payMentDetails{
  .payin-status{
    text-align: center;
    position: absolute;
    top: 12px;
    left: 160px;
  }
}
</style>
